
frontLoggerModule.service('FrontLogger', ['$http', function ($http) {

    const Category = Object.freeze({
        Front: 'Front',
        Translation: 'Translation',
    });

    const Step = Object.freeze({
        Search: 'Search',
        AirResult: 'AirResult',
    });
    function send(endpoint, payload) {
        const data = {
            message: payload.message,
            category: payload.category,
            step: payload.step,
            properties: payload.properties || {},
            url: window.location.href,
            userAgent: navigator.userAgent,
            requestId: payload.requestId || null
        };

        return $http.post('/api/api/Logger/' + endpoint, data);
    }

    const api = {
        Category,
        Step,
        info: function (message, options = {}) {
            return send('Info', Object.assign({ message }, options));
        },
        warn: function (message, options = {}) {
            return send('Warn', Object.assign({ message }, options));
        },
        error: function (message, options = {}) {
            return send('Error', Object.assign({ message }, options));
        }
    };

    return api;
}]);